// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__1XvZr","wrapper":"styles_wrapper__2U-Nx","icon":"styles_icon__OFb9M"};